<div wrapperComponent class="groups-menu-wrap">
  <div>
    <a translate class="nav-link" componentLink>All Categories</a>
    <div class="" componentContent [ngStyle]="{'background-image': bgImg ? 'url(' + bgImg + ')' : ''}">
      <span class="close-btn" closeComponent>&times;</span>
      @for (glColumn of groupsMenuLinks; track glColumn) {
        <div class="groups-menu-column">
          @for (gl of glColumn; track gl) {
            <a class="outlined groups-menu-item" routerLink="{{gl.link}}">
              <div class="text-truncate groups-menu-name" closeComponent translate [innerHTML]="gl.group_name"></div>
            </a>
          }
        </div>
      }
    </div>
  </div>
</div>
